package com.milta.feature.auth.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class OtpSendRequest(val phoneNumber: String)
